import React from 'react';
import { Text, Link, Checkbox } from '@gasbuddy/react-components';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './TermsOfService.module.css';
import LINKS from '../../constants/links';
import formatPrice from '../../../lib/utils/formatPrice';

const cx = classnames.bind(styles);

export default function TermsOfService({
  buttonText,
  onCheck,
  isAnnualMembership,
  annualPrice,
}) {
  const handleTermsChecked = (e) => {
    if (onCheck) {
      onCheck(e.target.checked);
    }
  };

  if (isAnnualMembership) {
    return (
      <Checkbox
        id="annualTermsAcceptance"
        name="acceptedAnnualTerms"
        onClick={handleTermsChecked}
        label={(
          <Text as="small">
            By checking this box, I agree that my subscription will renew automatically each year.
            My bank account on file will be charged {formatPrice(annualPrice.initialPrice, 2)} today and then {annualPrice.renewalPrice === annualPrice.initialPrice ? 'the current price' : `${formatPrice(annualPrice.renewalPrice, 2)}`} at each renewal each year
            unless I cancel before the end of the current billing period. I can cancel through my GasBuddy Account settings.
            See Membership Terms for full details. <Link bold href={LINKS.GB_ANNUAL_MEMBERSHIP_TERMS} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions.</Link>
          </Text>
        )}
        className={cx('checkbox')}
      />
    );
  }

  return (
    <Checkbox
      id="termsAcceptance"
      name="acceptedTerms"
      onClick={handleTermsChecked}
      label={(
        <Text as="small">
          By checking this box and clicking &quot;{buttonText}&quot; you are verifying that the information entered above is correct,
          and you are agreeing to GasBuddy’s&nbsp;
          <Link bold href={LINKS.GB_TERMS} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</Link>,&nbsp;
          <Link bold href={LINKS.GB_PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">Privacy Policy</Link>, and&nbsp;
          <Link bold href={LINKS.GB_CHARGE_CARD_AGREEMENT} target="_blank" rel="noopener noreferrer">GasBuddy Charge Card Agreement</Link>
          &nbsp;as well as our partner Dwolla&apos;s&nbsp;
          <Link bold href={LINKS.DWOLLA_TERMS} target="_blank" rel="noopener noreferrer">Terms of Service</Link>
          &nbsp;and&nbsp;
          <Link bold href={LINKS.DWOLLA_PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">Privacy Policy</Link>.
        </Text>
      )}
      className={cx('checkbox')}
    />
  );
}

TermsOfService.propTypes = {
  buttonText: PropTypes.string,
  onCheck: PropTypes.func,
  isAnnualMembership: PropTypes.bool,
  annualPrice: PropTypes.shape({
    initialPrice: PropTypes.string,
    renewalPrice: PropTypes.string,
  }),
};

TermsOfService.defaultProps = {
  buttonText: 'Submit',
  onCheck: undefined,
  isAnnualMembership: false,
  annualPrice: {
    initialPrice: undefined,
    renewalPrice: undefined,
  },
};
